import React, { useState, useEffect, useContext } from "react";
import bannerImg from "./styles/img/banner.jpg";
import logoImg from "./styles/img/logo.svg";
import styles from "./styles/WelcomePopup.module.css";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import useWindowDimensions from "../../Footer/footer";
import { ReactComponent as ReferralSvg } from "./styles/img/referral.svg";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { formatTime } from "../../../Utils/formatTime";

export function ReferralLoginPopup({ couponData }) {
  const [showPopup, setShowPopup] = useState(true);
  const { width } = useWindowDimensions();
  const navigate = useNavigate();

  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const closePopup = () => {
    setShowPopup(false);
    localStorage.setItem("showReferralPopup", false);
  };

  return (
    <>
      {showPopup && (
        <div className={styles.popup_container}>
          <div
            className={styles.popup}
            style={{
              width: "640px",
            }}
          >
            <div className={styles.header}>
              <div className={styles.title}>
                <div>{dublicatedcontent?.welcome_to}</div>
                <div className={styles.logo_row}>
                  <img className={styles.logo} src={logoImg} alt="Ostreon" />
                  <span>Inheritance!</span>
                </div>
              </div>
              <div className={styles.subtitle}>
                {dublicatedcontent?.dublicatedText236}
              </div>
              <button
                className={styles.close_btn}
                onClick={closePopup}
              ></button>
            </div>
            <img
              className={styles.img}
              src={bannerImg}
              alt={`${dublicatedcontent?.welcome_to} Ostreon`}
            />
            <div className={styles.footer}>
              <div className={styles.referral}>
                <ReferralSvg />
                <p
                  style={{
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                >
                  {dublicatedcontent.dublicatedText201}
                </p>
                <div
                  className={styles.referralCode}
                  style={
                    !couponData?.amount_off &&
                    !couponData?.percent_off &&
                    !couponData?.time
                      ? { marginBottom: "3px" }
                      : {}
                  }
                >
                  <p>{couponData?.code}</p>
                </div>
                {couponData?.amount_off && (
                  <div className={styles.referralCodeContainer}>
                    <span>{dublicatedcontent.dublicatedText202}</span>
                    <br />
                    <span
                      style={{
                        color: "#0091EA",
                        fontWeight: "500",
                      }}
                    >
                      {dublicatedcontent.dublicatedText203}
                      {couponData?.amount_off_currencies["usd"]}
                      &nbsp;{dublicatedcontent.dublicatedText204}
                    </span>
                    <br />
                    <span
                      style={{
                        color: "#0091EA",
                      }}
                    >
                      {dublicatedcontent.dublicatedText205}
                    </span>
                  </div>
                )}
                {couponData?.percent_off && !couponData?.applies_to && (
                  <div className={styles.referralCodeContainer}>
                    <span>{dublicatedcontent.dublicatedText202}</span>

                    <br />
                    <span
                      style={{
                        color: "#0091EA",
                        fontWeight: "500",
                      }}
                    >
                      {dublicatedcontent.dublicatedText206}{" "}
                      {couponData?.percent_off}
                      %&nbsp;{dublicatedcontent.dublicatedText207}
                    </span>
                    <br />
                    <span
                      style={{
                        color: "#0091EA",
                      }}
                    >
                      {dublicatedcontent.dublicatedText205}
                    </span>
                  </div>
                )}
                {couponData?.percent_off && couponData?.applies_to && (
                  <div className={styles.referralCodeContainer}>
                    <span>
                      {dublicatedcontent.for_a_subscription_of_a_plan?.replace(
                        "plan_names",
                        couponData?.applies_to
                          ?.map(
                            (product) =>
                              product?.metadata[
                                `${websiteCurrentLang?.label}_name`
                              ]?.toLowerCase() || product?.name?.toLowerCase()
                          )
                          .join(` ${dublicatedcontent.or} `)
                      )}
                    </span>

                    <br />
                    <span
                      style={{
                        color: "#0091EA",
                        fontWeight: "500",
                      }}
                    >
                      {dublicatedcontent.you_will_receive_discount_initial_price?.replace(
                        "discount_percentage",
                        `${couponData?.percent_off}`
                      )}
                    </span>
                    <br />
                    <span
                      style={{
                        color: "#0091EA",
                      }}
                    >
                      {dublicatedcontent.dublicatedText205}
                    </span>
                  </div>
                )}
                {couponData?.time && (
                  <div className={styles.referralCodeContainer}>
                    <span>{dublicatedcontent.dublicatedText202}</span>
                    <br />
                    <span>
                      {dublicatedcontent.you_will_receive}&nbsp;
                      {formatTime(couponData?.time, dublicatedcontent, true)?.toLowerCase()}
                      &nbsp;{dublicatedcontent.dublicatedText208}
                    </span>
                    <br />
                    <span
                      style={{
                        color: "#0091EA",
                        fontWeight: "500",
                      }}
                    >
                      {dublicatedcontent.dublicatedText209} &nbsp;
                      {dublicatedcontent?.price_format
                        ?.replace(
                          "currency_",
                          dublicatedcontent?.main_currency_symbol
                        )
                        ?.replace(
                          "amount_",
                          ((97 / 31536000000) * Math.round(couponData?.time)).toFixed(0)
                        )}
                    </span>
                    <br />
                    <span
                      style={{
                        color: "#0091EA",
                      }}
                    >
                      {dublicatedcontent.dublicatedText205}
                    </span>
                  </div>
                )}
                {(couponData?.amount_off ||
                  couponData?.percent_off ||
                  couponData?.time) && (
                  <div
                    className={styles.buttonContainer}
                    style={{
                      marginTop: "15px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        position: "relative",
                      }}
                    >
                      <Button
                        style={{
                          backgroundColor: "rgba(0, 145, 234, 1)",
                          width: "max-content",
                        }}
                        onClick={(e) => {
                          navigate("/user/plan");
                          closePopup();
                        }}
                        className={styles.button}
                      >
                        {dublicatedcontent.dublicatedText240}
                      </Button>
                      <p className={styles.buttonText}>
                        {dublicatedcontent.dublicatedText241}
                      </p>
                    </div>
                    <Button
                      onClick={(e) => {
                        closePopup();
                      }}
                      style={
                        websiteCurrentLang?.label === "fr" && width > 670
                          ? {
                              right: "50px",
                            }
                          : {}
                      }
                      className={`${styles.button} ${styles.button_absolute}`}
                    >
                      {dublicatedcontent.dublicatedText242}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ReferralLoginPopup;
